import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { makeStyles } from '@mui/styles'
import VisibilityIcon from '@mui/icons-material/Visibility'
import getButtonCell from 'components/generic/datagrid/cells/ButtonCell'
import DataGridWithSearchV2 from 'components/generic/datagrid/DataGridWithSearchV2'
import { SORTABLE_CUSTOMER_FIELDS } from 'utils/constants'
import { generateRenderHeaderFunction } from 'utils/generateRenderHeaderFunction'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: theme.spacing(0),
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      paddingLeft: theme.spacing(0.75),
      paddingRight: theme.spacing(0.75),
    },
    '& .MuiDataGrid-columnHeaderTitleContainer .MuiCheckbox-root': {
      visibility: 'hidden',
    },
  },
}))

const getColumns = (navigate, renderHeaderWithSort) => [
  {
    field: 'miniId',
    headerName: 'ID #',
    flex: 1,
    sortable: false,
  },
  {
    field: 'accountName',
    headerName: 'Account Name',
    flex: 1,
    sortable: false,
    renderHeader: () => renderHeaderWithSort('Account Name', SORTABLE_CUSTOMER_FIELDS.DISPLAY_NAME),
  },
  {
    field: 'customerType',
    headerName: 'Customer Type',
    flex: 1,
    sortable: false,
  },
  {
    field: 'supplierType',
    headerName: 'Type',
    flex: 1,
    sortable: false,
    renderHeader: () => renderHeaderWithSort('Type', SORTABLE_CUSTOMER_FIELDS.TYPE),
  },
  {
    field: 'vendorClass',
    headerName: 'Vendor Class',
    flex: 1,
    sortable: false,
    renderHeader: () => renderHeaderWithSort('Vendor Class', SORTABLE_CUSTOMER_FIELDS.VENDOR_CLASS),
  },
  {
    field: 'priceList',
    headerName: 'Price List',
    flex: 1,
    sortable: false,
  },
  {
    field: 'view',
    headerName: 'Actions',
    type: 'actions',
    width: 150,
    renderCell: params => getButtonCell(params, 'View', <VisibilityIcon />, () => navigate(`${params.row.id}/account`)),
  },
]

const CustomerGrid = props => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { filter, setFilter } = props

  const renderHeaderWithSort = useMemo(() => generateRenderHeaderFunction(filter, setFilter), [filter])

  return (
    <DataGridWithSearchV2
      {...props}
      className={classes.root}
      checkboxSelection
      useBackendSortAndFilter
      filter={filter}
      setFilter={setFilter}
      columns={getColumns(navigate, renderHeaderWithSort)}
      disableSelectionOnClick
    />
  )
}

CustomerGrid.propTypes = DataGridWithSearchV2.propTypes

CustomerGrid.defaultProps = DataGridWithSearchV2.defaultProps

export default CustomerGrid
